import PropTypes from 'prop-types';
import Icon from '../../../../client/Juno/client/icons/Icon';
import AmountWithCurrency from '../../common/AmountWithCurrency';

const ExchangeForm = ({
    formData,
    setFormData,
    fieldError,
    setFieldError,
    handleAmountChange,
    handleCurrencyChange,
    exchangeRate,
    loadingRate,
    updatedUnfreeze,
}) => {
    const handleExchangeCurrency = () => {
        setFormData(prev => ({
            ...prev,
            fromCrypto: prev.toCrypto,
            toCrypto: prev.fromCrypto,
            fromAmount: prev.toAmount,
            toAmount: prev.fromAmount,
        }));

        setFieldError({
            fromCrypto: '',
            toCrypto: '',
            fromAmount: '',
            toAmount: '',
        });
    };
    return (
        <>
            <div className="relative">
                <div className="flex flex-col gap-[20px] items-center w-full rounded-lg">
                    <AmountWithCurrency
                        errorMessage={fieldError.fromCrypto || fieldError.fromAmount}
                        isErrorVisible={false}
                        transactionLabel="From"
                        data={updatedUnfreeze?.filter(crypto => crypto?.currencyShortName != formData.toCrypto?.currencyShortName) || []}
                        amountValue={formData.fromAmount}
                        selected={formData.fromCrypto}
                        onAmountChange={e => handleAmountChange('fromAmount', e.target.value)}
                        onCurrencyChange={val => handleCurrencyChange('fromCrypto', val)}
                        dataE2e="from-crypto"
                    />

                    <AmountWithCurrency
                        errorMessage={fieldError.toCrypto || fieldError.toAmount}
                        isErrorVisible={false}
                        transactionLabel="To"
                        data={updatedUnfreeze?.filter(crypto => crypto?.currencyShortName != formData.fromCrypto?.currencyShortName) || []}
                        amountValue={formData.toAmount}
                        selected={formData.toCrypto}
                        onAmountChange={e => handleAmountChange('toAmount', e.target.value)}
                        onCurrencyChange={val => handleCurrencyChange('toCrypto', val)}
                        dataE2e="to-crypto"
                    />
                </div>

                <div
                    className="absolute cursor-pointer left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    onClick={handleExchangeCurrency}>
                    <span className="w-10 h-10 flex justify-center items-center !bg-primary rounded-lg border">
                        <Icon id="exchangeIcon" className="invert dark:invert-0" />
                    </span>
                </div>
            </div>

            {(fieldError.fromCrypto ||
                fieldError.fromAmount ||
                fieldError.toCrypto ||
                fieldError.toAmount ||
                fieldError.quotation) && (
                <p className="text-error text-sm mt-1 font-normal font-Inter uppercase"
                data-e2e-error="alert"
                    data-e2e={
                        fieldError.fromCrypto ||
                        fieldError.fromAmount ||
                        fieldError.toCrypto ||
                        fieldError.toAmount ||
                        fieldError.quotation
                    }
>
                    {fieldError.fromCrypto ||
                        fieldError.fromAmount ||
                        fieldError.toCrypto ||
                        fieldError.toAmount ||
                        fieldError.quotation}
                </p>
            )}
            <div className="text-sm w-full font-medium flex items-center gap-2 bg-card-bg justify-center py-2 mt-3 rounded-lg">
                {loadingRate && (
                    <div className="animate-spin h-[18px] w-[18px] border-2 border-[#A0A0AB4D] rounded-full border-t-2 !border-t-primary" />
                )}
                <span className="!text-text">
                    1 {formData.fromCrypto?.currencyShortName} ={' '}
                    {exchangeRate !== null ? exchangeRate : '?'}{' '}
                    {formData.toCrypto?.currencyShortName}
                </span>
            </div>
        </>
    );
};

ExchangeForm.propTypes = {
    formData: PropTypes.shape({
        fromCrypto: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        toCrypto: PropTypes.shape({
            currencyShortName: PropTypes.string,
            data: PropTypes.array,
        }),
        fromAmount: PropTypes.string,
        toAmount: PropTypes.string,
    }),
    fieldError: PropTypes.shape({
        fromCrypto: PropTypes.string,
        toCrypto: PropTypes.string,
        fromAmount: PropTypes.string,
        toAmount: PropTypes.string,
    }),
    handleAmountChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    exchangeRate: PropTypes.string,
    loadingRate: PropTypes.bool,
};

export default ExchangeForm;
